import enLocale from 'date-fns/locale/en-GB';
import nlLocale from 'date-fns/locale/nl';

export const localeMap = {
  en: enLocale,
  nl: nlLocale
};
